import { createSelector } from 'reselect';
import { bookingFilterSelector } from './bookingFilter';

export const lessonsBookingFilterSelector = createSelector(
    bookingFilterSelector,
    ({ lessons }) => lessons,
);
